/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ConfigureProduct.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Sivateja.P(H27743)
 *
 * @Date                : Jul 29, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Sivateja (H267743)
 * On            : Aug 14, 2019
 * Description   : Integrated save to cart , get cart details servcies , updated respective reducers(ASDS-909)
 *
 * By            : H352615
 * On            : Aug 26, 2019
 * Description   : Updated code as ASDS-1084.
 *
 * By            : H352615
 * On            : Aug 27, 2019
 * Description   : Add Loader for fetching features - ASDS-1084
 *
 * By            : Sivateja (H267743)
 * On            : Aug 14, 2019
 * Description   : storing the products in cart in store(ASDS-1048)
 *
 * By            : Sivateja (H267743)
 * On            : Sept 19, 2019
 * Description   : Added reducers for edit buttons in confirm-configuration tab (ASDS-1047)
 *
 * By            : H224423
 * On            : Sep 25, 2019
 * Description   : ASDS-411 Edit cart Item Aspire changes
 *
 * By            : H224423
 * On            : Sep 30, 2019
 * Description   : ASDS-412 Edit cart details changes
 *
 * By            : SandeepRaja (E807238)
 * On            : Oct 9, 2019
 * Description   : ASDS-594: Bulk Configuration - Confirm Configuration
                    - UI (Static)
*
 * By            : Madhu Gali - H175591
* On            : 18 Oct 2019
* Description   : ASDS-1549
 * By            : H224423
 * On            : Oct 21, 2019
 * Description   : ASDS-1548 changes.
 *
* By            : E860178
* On            : Oct 24, 2019
* Description   : Category Name added to Save cart details - ASDS-1598
*
* By            : E807238
* On            : Nov 1, 2019
* Description   : ASDS-1673: Add To Cart Conformation UI & Integration

*
* By            : E844276
* On            : Nov 18, 2019
* Description   : Added generic product functionalities - removed from products
 *
 * By            : H224423
 * On            : 25 Nov 2019
 * Description   : Added bulk upload validation error message.
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Jan 9th, 2020
 * Description   : updated the code for ASDS-1081
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Feb 17th, 2020
 * Description   : updated the code Product Test cases - removed unused code
 *
 * By            : E844276
 * On            : Feb 27 2020
 * Description   : Aspire - On features service failure - stop loader - ASDS-2345
 *
 * By            : H422335
 * On            : 14 Oct 2020
 * Description   : ASDS-3035 Migration of DCE Endpoints to new Forge Environment API
 *
 * By            : H422337
 * On            : 03 Nov 2020
 * Description   : ASDS-3823 - Aspire UI enhancements of Phase-2
 *
 * By            : H422337
 * On            : Nov 04, 2020
 * Description   : ASDS-3572,ASDS-3573 Enhancements of phase-2 - Edit Aspire product changes
 *
 * By            : H422337
 * On            : 03 Nov 2020
 * Description   : ASDS-3824 - Migration of DCE Endpoints to new Forge Environment API and UI enhancements of Phase-2
 *
******************************************************************************/

import Reducer from './reducer';
import { AsdsReduxAction } from '../../../../types';
import { createReducer } from '../utils/redux-util';
import ActionConstants from '../action-constants';
import { SubProductsRes } from '../../../../types/index';
import { logInfo } from '../../../../utils/console-utility';

class ConfigureProductReducer extends Reducer {
  static setProductFeatureList(state, action: AsdsReduxAction) {
    const productFeaturesResponse: SubProductsRes[] =
      action.payload.response;
    return {
      payload: {
        ...state.payload,
        featuresMasterData: productFeaturesResponse,
        isFetching: false,
        isSuccess: true,
        isFeatureMasterDataFetching: false
      }
    };
  }

  static getProductFeatureList(state, action: AsdsReduxAction) {
    return {
      payload: {
        ...state.payload,
        isFeatureMasterDataFetching: action.payload.isFeatureMasterDataFetching
      }
    };
  }

  static addNewFeature(state, action: AsdsReduxAction) {
    return {
      payload: {
        ...state.payload,
        productFeatures: action.payload.newProductFeatures,
        enableNextBtn: action.payload.enableNextBtn
      }
    };
  }

  static updateFeature(state, action: AsdsReduxAction) {
    return {
      payload: {
        ...state.payload,
        productFeatures: action.payload.features,
        totalPrice: action.payload.totalPrice,
        enableNextBtn: action.payload.enableNextBtn
      }
    };
  }

  static deleteFeature(state, action: AsdsReduxAction) {
    return {
      payload: {
        ...state.payload,
        productFeatures: action.payload.featuresCopy,
        totalPrice: action.payload.totalPrice,
        enableNextBtn: action.payload.enableNextBtn
      }
    };
  }

  static addNewSerial(state, action: AsdsReduxAction) {
    return {
      payload: {
        ...state.payload,
        serialNumbers: action.payload.updatedSerials,
        enableNextBtn: action.payload.enableNextBtn,
        totalPrice: action.payload.totalPrice
      }
    };
  }

  static updateSerial(state, action: AsdsReduxAction) {
    return {
      payload: {
        ...state.payload,
        serialNumbers: action.payload.validatedSerials,
        enableNextBtn: action.payload.enableNextBtn
      }
    };
  }

  static deleteSerial(state, action: AsdsReduxAction) {
    return {
      payload: {
        ...state.payload,
        serialNumbers: action.payload.serials,
        totalPrice: action.payload.totalPrice,
        enableNextBtn: action.payload.enableNextBtn
      }
    };
  }

  static modifyActiveTab(state, action: AsdsReduxAction) {
    return {
      payload: {
        ...state.payload,
        activeTab: action.payload.activeTab,
        enableNextBtn: action.payload.enableNextBtn
      }
    };
  }

  static updateActiveTab(state, action: AsdsReduxAction) {
    return {
      payload: {
        ...state.payload,
        activeTab: action.payload.activeTab
      }
    };
  }

  static backButtonHandle(state, action: AsdsReduxAction) {
    logInfo('backButtonHandle: ' + action.payload.activeTab);
    return {
      payload: {
        ...state.payload,
        activeTab: action.payload.activeTab,
        enableNextBtn: action.payload.enableNextBtn
      }
    };
  }

  static onClickConfigureButton(state, action: AsdsReduxAction) {
    return {
      payload: {
        ...state.payload,
        configureModelOpen: action.payload.configureModelOpen,
        product: action.payload.product,
        system: action.payload.system,
        categoryName: action.payload.categoryName
      }
    };
  }

  static resetConfigProductData(state) {

    // reset the configure product modal data.
    return {
      payload: {
        ...state.payload,
        featuresMasterData: [],
        productFeatures: [
          {
            subProductId: '',
            subProductName: '',
            subProductDesc: '',
            partNumber: '',
            validity: '',
            unitPrice: '0.00',
            extendedPrice: '0.00',
            partNumberError: '',
            validityError: ''
            // discountedPrice: '',
            // discountPercentage: ''
          }
        ],
        serialNumbers: [{ serialNumber: '', error: '' }],
        totalPrice: 0.0,
        isFetching: true,
        isSuccess: false,
        activeTab: 1,
        enableNextBtn: false,
        configureModelOpen: false,
        activeMainTabIndex: 0,
        productId: "",
        redirectTo: undefined,
        bulkError: "",
        editCartProductDetails: {
          productSeq: 0,
          id: 0,
          seq: 0,
      cartSeq: 0
        }
      }
    };
  }

  static addProductToCart(state, action: AsdsReduxAction) {
    return {
      payload: {
        ...state.payload,
        productsInCart: action.payload.productsInCart,
        conflictingProductInCart: action.payload.conflictingProductInCart
      }
    };
  }

  static setProductsInCart(state, action: AsdsReduxAction) {
    return {
      payload: {
        ...state.payload,
        productsInCart: action.payload.productsInCart
      }
    };
  }

 
  /**
   * @param state Method to map product details from mycart page to configure product object
   * @param action
   */
  static presetProductDetails(state, action: AsdsReduxAction) {
    let newState: any = {
      ...state
    };
    newState.payload.productFeatures = action.payload.productFeatures;
    newState.payload.serialNumbers = action.payload.serialNumbers;
    newState.payload.totalPrice = action.payload.product.totalPrice;
    newState.payload.enableNextBtn = true; 
    newState.payload.product.productId = action.payload.product.prodId;
    newState.payload.product.productDesc = action.payload.product.prodDesc;
    newState.payload.product.productName = action.payload.product.prodName;
    newState.payload.categoryName = action.payload.product.categoryName;
    newState.payload.system = action.payload.product.system;
    newState.payload.editCartProductDetails = {
      productSeq: action.payload.product.aspire[0].prodSeq,
      id: action.payload.product.id,
      cartSeq: action.payload.product.cartSeq,
      seq: action.payload.product.seq
    };
    return newState;
  }

  static setExcelConfData(state, action: AsdsReduxAction) {
    let newState: any = {
      ...state
    };
    newState.payload.productFeatures = action.payload.subProductsList;
    newState.payload.serialNumbers = action.payload.serialNumbers;
    newState.payload.enableNextBtn = true; // enabling next button
    newState.payload.totalPrice = action.payload.totalPrice;
    newState.payload.bulkValidationError = action.payload.bulkValidationError;
    return newState;
  }

  /**
   * Method to toggle main tab in product configuration between
   *                      Configuration and Bulk Configuration
   * @param action
   */
  static mainTabToggle(state, action: AsdsReduxAction) {
    return {
      payload: {
        ...state.payload,
        activeTab: action.payload.activeMainTabIndex === 0 ? 1 : 4,
        activeMainTabIndex:  action.payload.activeMainTabIndex,
        enableNextBtn: action.payload.enableNextBtn
      }
    };
  }

  static validateUploadedBulkConfigFile(state, action: AsdsReduxAction) {
    return {
      payload: {
        ...state.payload,
        uploadedConfigFile: action.payload.uploadedConfigFile,
        enableNextBtn: action.payload.enableNextBtn,
        bulkError: ''
      }
    };
  }

  static closeAspireModel(state) {
    // show product Successfully added to cart Alert model.
    return {
      payload: {
        ...state.payload,
        configureModelOpen: false
      }
    };
  }

  static displayBulkError(state, action: AsdsReduxAction) {
    return {
      payload: {
        ...state.payload,
        bulkError: action.payload.bulkError
      }
    };
  }
  static showAspireNotificationMsg(state, action: AsdsReduxAction) {
    return {
      payload: {
        ...state.payload,
        showAspireErrorValidationMsg: action.payload.showAspireErrorValidationMsg
      }
    };
  }
}

const productFeatureHandlers = {
  [ActionConstants.SET_PRODUCT_FEATURES]:
    ConfigureProductReducer.setProductFeatureList,
  [ActionConstants.ADD_NEW_FEATURE]: ConfigureProductReducer.addNewFeature,
  [ActionConstants.UPDATE_FEATURE]: ConfigureProductReducer.updateFeature,
  [ActionConstants.DELETE_FEATURE]: ConfigureProductReducer.deleteFeature,
  [ActionConstants.RESET_CONFIGURE_PRODUCT]:
    ConfigureProductReducer.resetConfigProductData,
  [ActionConstants.ADD_NEW_SERIAL]: ConfigureProductReducer.addNewSerial,
  [ActionConstants.UPDATE_SERIAL_NUMBER]: ConfigureProductReducer.updateSerial,
  [ActionConstants.DELETE_SERIAL_NUMBER]: ConfigureProductReducer.deleteSerial,
  [ActionConstants.GO_TO_CONFIGURE_FEATURES]:
    ConfigureProductReducer.modifyActiveTab,
  [ActionConstants.GO_TO_CONFIRM_FEATURES]:
    ConfigureProductReducer.updateActiveTab,
  [ActionConstants.BACK_BUTTON_HANDLE]:
    ConfigureProductReducer.backButtonHandle,
  [ActionConstants.CONFIGURE_PRODUCT_MODEL]:
    ConfigureProductReducer.onClickConfigureButton,
  [ActionConstants.ADD_PRODUCT_TO_CART]:
    ConfigureProductReducer.addProductToCart,
  [ActionConstants.GET_PRODUCT_FEATURES]:
    ConfigureProductReducer.getProductFeatureList,
  [ActionConstants.LOAD_CART_DATA]: ConfigureProductReducer.setProductsInCart,
  [ActionConstants.GOTO_SERIAL_NUMBERS_TAB]:
    ConfigureProductReducer.updateActiveTab,
  [ActionConstants.GOTO_CONFIGURE_FEATURES_TAB]:
    ConfigureProductReducer.updateActiveTab,
  [ActionConstants.GOTO_STEP1_SERIAL_NUMBERS_TAB]:
    ConfigureProductReducer.updateActiveTab,
  [ActionConstants.GOTO_STEP1_CONFIGURE_FEATURES_TAB]:
    ConfigureProductReducer.updateActiveTab,
  [ActionConstants.PRESET_CONFIGURE_PRODUCT_MYCART]:
    ConfigureProductReducer.presetProductDetails,
  [ActionConstants.CONFIGURE_PRODUCT_MAIN_TAB_CHANGE]:
    ConfigureProductReducer.mainTabToggle,
  [ActionConstants.GO_TO_BULK_CONFIRM_ORDER]:
    ConfigureProductReducer.updateActiveTab,
  [ActionConstants.SET_EXCEL_CONF_DATA]:
    ConfigureProductReducer.setExcelConfData,
  [ActionConstants.VALIDATE_UPLOADED_BULK_CONFIG_FILE]:
    ConfigureProductReducer.validateUploadedBulkConfigFile,
  [ActionConstants.GOTO_BULK_FILE_UPLOAD_TAB]:
    ConfigureProductReducer.modifyActiveTab,
  [ActionConstants.CLOSE_ASPIRE_MODEL]:
    ConfigureProductReducer.closeAspireModel,
  [ActionConstants.DISPLAY_BULK_EXCEL_ERROR]:
    ConfigureProductReducer.displayBulkError,
  [ActionConstants.SHOW_FEATURE_NOTIFICATION]:
    ConfigureProductReducer.showAspireNotificationMsg
};

const initialState = {
  payload: {
    featuresMasterData: [],
    productFeatures: [
      {
        subProductId: "",
        subProductName: "",
        subProductDesc: "",
        partNumber: "",
        validity: "",
        unitPrice: "0.00",
        extendedPrice: "0.00",
        partNumberError: "",
        validityError: "",
        discountedPrice: "",
        discountPercentage: "",
        showFeatureNotification: true,
        seq: 0,
        productSeq: 0
      }
    ],
    serialNumbers: [{ serialNumber: "", error: "" }],
    totalPrice: 0.0,
    isFetching: true,
    isSuccess: false,
    activeTab: 1, // Active tab index in the configure product modal
    activeMainTabIndex: 0, // Active tab index in the configure product modal
    enableNextBtn: false, // based on this field we will enable/disable the NEXT button in configure product modal.
    configureModelOpen: false, // using this show/hide the configure product model.
    product: {},
    system: "", // tells the Selected product is of which system, "Apptus" or "Bms"
    productsInCart: [], // ALL the product in Cart are stored in the field.
    redirectTo: undefined,
    isFeatureMasterDataFetching: false,
    showAspireErrorValidationMsg: true,
    editCartProductDetails: {
      productSeq: 0,
      id: 0,
      seq: 0,
      cartSeq: 0

    }, // used when component loaded from cart page
    bulkValidationError: "",
    bulkError: ""
  }
};

export const configProductData = createReducer(
  initialState,
  productFeatureHandlers
);
